import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import CookieBanner from './components/CookieBanner';
import { ConsentProvider } from './contexts/ConsentContext';
import '../styles/base.css';
import '../styles/components.css';
import '../styles/responsive.css';

// Analytics consent is checked at replay initialization time in App.jsx.
// We initialize Sentry here (without replay) so error capture works immediately.
// Replay integration is added dynamically if the user grants analytics consent.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

createRoot(document.getElementById('root')).render(
  <ConsentProvider>
    <ErrorBoundary>
      <App />
      <CookieBanner />
    </ErrorBoundary>
  </ConsentProvider>
);
